export function calculatePrice(form, pricingConfig) {
  // pricingConfig is null until GET /api/pricing resolves (Wizard.jsx mount) - returning a
  // real object with `total: 0` here made PriceSidebar briefly render "$0" / "$undefined"
  // (base_price was missing entirely) during that split-second, a broken-looking flash caught
  // on a slow mobile connection in a session recording (13/08/2026 user report). Returning
  // `null` instead lets PriceSidebar's existing `if (!pricing) return null` guard hide the
  // whole sidebar until real numbers are ready, instead of ever showing a fake price.
  if (!pricingConfig) return null;
  const b = {};
  b.base_price = pricingConfig.duration_prices[String(form.duration_minutes)] ?? pricingConfig.duration_prices["3"];
  b.versions_fee = pricingConfig.versions_fee[String(form.num_versions)] ?? 0;
  b.lyrics_fee = form.lyrics_mode === "auto" ? pricingConfig.lyrics_ai_fee : 0;
  b.voice_fee = form.voice_enabled ? pricingConfig.voice_fee : 0;
  b.vocal_style_fee = form.voice_enabled && form.vocal_style !== "standard" ? pricingConfig.vocal_style_premium_fee : 0;
  b.thumbnail_fee = form.thumbnail_ai ? pricingConfig.thumbnail_fee : 0;
  b.title_fee = form.title_mode === "custom" ? pricingConfig.custom_title_fee : 0;
  b.message_fee = form.message_position !== "none" ? pricingConfig.message_fee : 0;
  b.gift_fee = form.gift_enabled ? pricingConfig.gift_fee : 0;
  b.youtube_fee = form.youtube_publish_requested ? pricingConfig.youtube_publish_fee : 0;
  b.download_fee = form.download_mp3_included ? pricingConfig.download_mp3_fee : 0;
  b.rush_fee = form.rush_generation ? pricingConfig.rush_generation_fee : 0;
  b.bonus_instrumental_fee = form.bonus_instrumental && form.voice_enabled ? pricingConfig.bonus_instrumental_fee : 0;
  b.social_short_fee = form.social_short_format ? pricingConfig.social_short_fee : 0;
  b.translation_fee = form.translate_lyrics ? pricingConfig.translation_fee : 0;
  b.certificate_fee = form.gift_certificate ? pricingConfig.certificate_fee : 0;
  b.voice_message_fee = form.personal_voice_message ? pricingConfig.voice_message_fee : 0;
  const total = Object.values(b).reduce((a, c) => a + c, 0);
  return { ...b, total: Math.round(total * 100) / 100 };
}

export const DEFAULT_FORM = {
  style: "pop",
  mood: "romantique",
  subject: "",
  song_language: "fr",
  person_first_name: "",
  person_last_name: "",
  person_date: "",
  event_type: "autre",
  duration_minutes: 3,
  num_versions: 1,
  lyrics_mode: "auto",
  custom_lyrics: "",
  voice_enabled: true,
  voice_gender: "femme",
  vocal_style: "standard",
  thumbnail_ai: false,
  thumbnail_source: "ai",
  thumbnail_upload_path: null,
  title_mode: "auto",
  custom_title: "",
  message_position: "none",
  message_text: "",
  gift_enabled: false,
  gift_name: "",
  gift_email: "",
  gift_message: "",
  gift_send_date: "",
  youtube_publish_requested: false,
  download_mp3_included: false,
  rush_generation: false,
  bonus_instrumental: false,
  social_short_format: false,
  translate_lyrics: false,
  translate_target_language: "en",
  gift_certificate: false,
  public_gallery_opt_in: false,
  personal_voice_message: false,
  voice_message_text: "",
  voice_message_position: "intro",
};
